import { render, staticRenderFns } from "./PorletBuscadorCuadroMando.vue?vue&type=template&id=4a18e195"
import script from "./PorletBuscadorCuadroMando.vue?vue&type=script&lang=js"
export * from "./PorletBuscadorCuadroMando.vue?vue&type=script&lang=js"
import style0 from "./PorletBuscadorCuadroMando.vue?vue&type=style&index=0&id=4a18e195&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports